<template lang="html">
  <div>
    <app-title :title="lang[0]"></app-title>
    <div v-if="isLoading"></div>
    <div v-else>
      <div class="main-wrapper">
        <div class="user-form">
          <n-input
            v-model="userData.post_code"
            :placeholder="lang[1]"
            type="text"
            :action="{where: 'blur', method: 'zipSearch'}"
            @zipSearch="zipSearch"
          ></n-input>
        </div>

        <div v-if="this.userData.country === 'Japan'">
          <div class="user-form">
            <n-input
              v-model="userData.prefecture_kanji"
              placeholder="都道府県"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.address_kanji"
              placeholder="市区町村"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.street_kanji"
              placeholder="市区町村以下＆丁目（丁目と書いてくださいex:桃井1丁目）"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.line1_kanji"
              placeholder="丁目以降(ex:2-1)"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.line2_kanji"
              placeholder="マンション名など(ex:ひだまり荘)"
              type="text"
            ></n-input>
          </div>

          <div class="user-form">
            <n-input
              v-model="userData.prefecture_kana"
              placeholder="都道府県（カナ）"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.address_kana"
              placeholder="市区町村（カナ）"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.street_kana"
              placeholder="市区町村＆丁目（カナ ex:モモイ1チョウメ）"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.line1_kana"
              placeholder="番地（半角のみ ex: 2-1）"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.line2_kana"
              placeholder="マンション名など（カナ ex: ヒダマリソウ201）"
              type="text"
            ></n-input>
          </div>
        </div>

        <div v-else>
          <div class="user-form">
            <n-input
              v-model="userData.prefecture"
              placeholder="prefecture"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.address"
              placeholder="address"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.street"
              placeholder="street"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.line1"
              placeholder="line1"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.line2"
              placeholder="line2"
              type="text"
            ></n-input>
          </div>
        </div>

        <div v-if="this.userData.country === 'Japan'">
          <div class="user-form">
            <n-input
              v-model="userData.last_name_kanji"
              placeholder="お届け先の苗字"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.first_name_kanji"
              placeholder="お届け先の名前"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.last_name_kana"
              placeholder="お届け先の苗字（カナ）"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.first_name_kana"
              placeholder="お届け先の名前（カナ）"
              type="text"
            ></n-input>
          </div>
        </div>

        <div v-else>
          <div class="user-form">
            <n-input
              v-model="userData.first_name"
              placeholder="your first name"
              type="text"
            ></n-input>
          </div>
          <div class="user-form">
            <n-input
              v-model="userData.last_name"
              placeholder="your last name"
              type="text"
            ></n-input>
          </div>
        </div>

        <div class="user-form">
          <n-input
            v-model="userData.phone_number"
            :placeholder="`${lang[2]} ${globalCode}`"
            type="text"
          ></n-input>
        </div>
        <div class="user-form">
          <n-input
            v-model="userData.day"
            :placeholder="lang[3]"
            type="text"
          ></n-input>
        </div>
        <div class="user-form">
          <n-input
            v-model="userData.month"
            :placeholder="lang[4]"
            type="text"
          ></n-input>
        </div>
        <div class="user-form">
          <n-input
            v-model="userData.year"
            :placeholder="lang[5]"
            type="text"
          ></n-input>
        </div>
        <div class="user-form">
          <n-select v-model="userData.gender" :options="genderObj" :placeholder="lang[6]">
          </n-select>
        </div>

        <div class="btn-wrapper">
          <router-link :to="`/account/${this.$store.state.account.name}`">
            <btn size="normal" type="cancel" :label="lang[9]"></btn>
          </router-link>
          <btn size="normal" type="primary" :label="lang[10]" @click="stripeUpdate()" :loading="loading"></btn>
        </div>
      </div>
    </div>
    <app-menu active="profile"></app-menu>
    <notice v-if="isNotice" :title="noticeTitle" :text="noticeText" :type="noticeType"></notice>
  </div>
</div>
</template>

<script>
import axios from 'axios'
import Btn from '../../components/Button.vue'
import AppMenu from '../../components/Menu.vue'
import AppTitle from '../../components/Title.vue'
import Notice from '../../components/Notice.vue'
import NInput from '../../components/Input.vue'
import NSelect from '../../components/Select.vue'
import stripeCountryMaster from '../../masters/stripeCountryMaster'
import AccountAddressLangMaster from '../../masters/langMaster/AccountAddressLangMaster'
import axiosJsonpAdapter from 'axios-jsonp'
import stripeErrorHandle from '../../mixins/stripeErrorHandle.js'

export default {
  name: 'Profile address',
  components: {
    Btn,
    AppMenu,
    Notice,
    AppTitle,
    NInput,
    NSelect,
  },

  mixins: [stripeErrorHandle],

  data() {
    return {
      isLoading: true,
      lang: AccountAddressLangMaster[this.$store.state.account.lang],
      userData: {
        country: '',
        post_code: String,
        prefecture_kanji: String,
        prefecture_kana: String,
        address_kanji: String,
        address_kana: String,
        street_kanji: String,
        street_kana: String,
        first_name_kanji: String,
        first_name_kana: String,
        last_name_kanji: String,
        last_name_kana: String,
        phone_number: Number,
        day: Number,
        month: Number,
        year: Number,
        gender: String,
      },
      isNotice: '',
      loading: false,
      globalCode: '',
      genderObj: [
        {
          label: AccountAddressLangMaster[this.$store.state.account.lang][7],
          value: 'female',
        },
        {
          label: AccountAddressLangMaster[this.$store.state.account.lang][8],
          value: 'male',
        },
      ],
    }
  },

  created() {
    this.fetchData()
  },

  methods: {
    fetchData() {
      axios.get(`private/user_id/${this.$store.state.account.id}`).then((data) => {
        this.userData = data.data.user
        this.checkGlobalCode(this.userData.country)
      }).catch((err) => {
        console.log(err);
      });
    },

    zipSearch() {
      if(this.$store.state.account.country== 'Japan') {
        this.isLoading = true
        axios.get('//zipcloud.ibsnet.co.jp/api/search', {
          adapter: axiosJsonpAdapter,
          params:{
            zipcode: this.userData.post_code
          }
        }).then(data => {
          this.userData.prefecture_kanji = data.data.results[0].address1
          this.userData.address_kanji = data.data.results[0].address2
          this.userData.street_kanji = data.data.results[0].address3 + '1丁目'
          this.userData.prefecture_kana = data.data.results[0].kana1
          this.userData.address_kana = data.data.results[0].kana2
          this.userData.street_kana = data.data.results[0].kana3 + '1ﾁｮｳﾒ'
          this.isLoading = false
        }).catch(err => {
          console.log(err)
          this.isLoading = false
        })
      } else {
        return false
      }
    },

    checkGlobalCode(id) {
      //一旦クソコード、後に国際電話番号のマスターを作る
      if(id === "Japan") {
        this.globalCode = "+81"
      } else if(id === "United State") {
        this.globalCode = "+1"
      }
      this.isLoading = false
    },

    userUpdate() {
      this.userData.email = this.$store.state.account.email
      // this.userData.phone_number = this.userData.phone_number ? this.userData.phone_number : NULL
      axios.put(`private/user/${this.userData.id}`, this.userData)
      .then((data) => {
        this.noticeType = 'success'
        this.noticeTitle = 'success!'
        this.noticeText = 'Your data has been succeffly updated!!'
        this.isNotice = true
        setTimeout(this.closeNotice,5000)
        localStorage.setItem('nerzex.user', JSON.stringify(this.userData))
        this.$store.dispatch('account/find', JSON.parse(localStorage.getItem('nerzex.user')))
        this.loading = false
      }).catch((err) => {
        console.log(err)
        this.noticeType = 'alert'
        this.noticeTitle = 'Error'
        this.noticeText = err.message
        this.isNotice = true
        this.loading = false
        setTimeout(this.closeNotice,5000)
      });
    },

    stripeUpdate() {
      this.loading = true
      if(this.$store.state.account.stripe_id === null) {
        this.userUpdate()
      } else {
        let individual = {
          address: {
            country: stripeCountryMaster[this.$store.state.account.country],
            postal_code: this.userData.post_code,
            state: this.userData.prefecture,
            city: this.userData.address,
            town: this.userData.street,
            line1: this.userData.line1,
          },
          address_kanji: {
            country: stripeCountryMaster[this.$store.state.account.country],
            postal_code: this.userData.post_code,
            state: this.userData.prefecture_kanji,
            city: this.userData.address_kanji,
            town: this.userData.street_kanji,
            line1: this.userData.line1_kanji,
            line2: this.userData.line2_kanji,
          },
          address_kana: {
            country: stripeCountryMaster[this.$store.state.account.country],
            postal_code: this.userData.post_code,
            state: this.userData.prefecture_kana,
            city: this.userData.address_kana,
            town: this.userData.street_kana,
            line1: this.userData.line1_kana,
            line2: this.userData.line2_kana,
          },
          first_name: this.userData.first_name,
          last_name: this.userData.last_name,
          first_name_kanji: this.userData.first_name_kanji,
          last_name_kanji: this.userData.last_name_kanji,
          first_name_kana: this.userData.first_name_kana,
          last_name_kana: this.userData.last_name_kana,
          phone: this.userData.phone_number,
          dob: {
            day: this.userData.day,
            month: this.userData.month,
            year: this.userData.year,
          },
          gender: this.userData.gender,
        }
        let addressArray = ['address', 'address_kana', 'address_kanji', 'dob']

        for(let i = 0;i < addressArray.length;i++) {
          Object.keys(individual[addressArray[i]]).map(value => {
            if(!individual[addressArray[i]][value]) {
              delete individual[addressArray[i]][value]
            }
          })
        }
        Object.keys(individual).filter((value, index) => {
          if(individual[value] === null) {
            delete individual[value]
          }
        })
        if(this.userData.phone_number) {
          individual.phone = `${this.globalCode} ${this.userData.phone_number}`
        }
        if(this.userData.country !== 'Japan') {
          delete individual.address_kana
          delete individual.address_kanji
        }
        axios.post('/private/stripe/account/update',{
          id: this.$store.state.account.stripe_id,
          individual: individual,
        }).then(data => {
          this.userUpdate()
        }).catch(err => {
          this.stripeErrorHandling(err)
        })
      }
    }
  }
}
</script>

<style lang="css" scoped>
.main-wrapper {
  height: auto;
  margin-bottom: 100px;
}

.profile {
  margin-bottom: 70px
}

.user-form {
  margin: 40px 20px;
  display: flex;
}

.main {
  padding-bottom: 100px;
}

.btn-wrapper {
  margin: 50px auto 100px auto;
}


@media(min-width: 800px) {
  .user-image {
    height: 30vh;
  }

  .profile-wrapper {
    width: 90%;
    max-width: 800px;
    margin: 40px auto;
  }
}
</style>
